module.exports = __webpack_public_path__ + "img/liveview.0629640e.svg";